import { ContentNodeSelectorPanelComponent } from '@alfresco/adf-content-services';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'wk-content-node-selector-panel',
  templateUrl: './wk-content-node-selector-panel.component.html',
  styleUrls: ['./wk-content-node-selector-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'adf-content-node-selector-panel' },
  providers: [],
  standalone: false,
})
export class WkContentNodeSelectorPanelComponent extends ContentNodeSelectorPanelComponent {}
